<template>
  <b-container>
    <header class="header">
      <TheTitle class="header__title">銷售訂單</TheTitle>
       <DateTimePicker
          class="pt-4 header__search"
          v-model="dateRange"
          has-range
          has-shortcuts
          placeholder="選擇日期"
        ></DateTimePicker>
    </header>
    <OverviewList
      :overviews="overviews"
      v-stream:select="onOverviewSelect$"
      paymentStatusName="payment"
      :loading="loading"
    >
    </OverviewList>
      <div class="overview">
        <h2>銷售總合</h2>
        <div style="display:inline-block;" v-if="role === 'merchant'">
          <h3 id="pinkborder">溫馨提示 商戶需自行申請收款
            <img class="overview-item__icon"
              src="../../assets/img/help-24px-blue.svg"
              alt="Hover for help"
              id="tooltip-merchant-cash-out"
            />
            <b-tooltip
              target="tooltip-merchant-cash-out"
              placement="top"
              variant="light"
            >
              當符合收款要求，可於付費優惠券>收款狀態申請收款。
            </b-tooltip>
          </h3>

        </div>

      <MySwiper hide-pagination class="mb-3">
        <MySwiperSlide>
          <div class="overview-item">
            <div class="d-flex flex-wrap">
              <div class="haft">
                <span class="overview-item__label">總銷售額
                  <img class="overview-item__icon"
                      src="../../assets/img/help-24px-blue.svg"
                      alt="Hover for help"
                      id="tooltip-merchant-total-price"
                  />
                  <b-tooltip
                    target="tooltip-merchant-total-price"
                    placement="top"
                    variant="light"
                  >
                    <p style="text-align:left;">總銷售額並不包括退款之行政成本及其他手續費。退款之行政成本將會於月結單上顯示。</p>
                  </b-tooltip>
                </span>
                <span v-if="salesOverview" class="overview-item__amount">
                  {{ formatCurrency(salesOverview.salesTotal) }}</span>
              </div>
            </div>
          </div>
        </MySwiperSlide>
        <MySwiperSlide>
          <div class="overview-item">
            <div class="d-flex flex-wrap">
                <div class="haft">
                  <span class="overview-item__label">總利潤
                  <img class="overview-item__icon"
                      src="../../assets/img/help-24px-blue.svg"
                      alt="Hover for help"
                      id="tooltip-merchant-receivable-price"
                  />
                  <b-tooltip
                    target="tooltip-merchant-receivable-price"
                    placement="top"
                    variant="light"
                  >
                   <p style="text-align:left;">總利潤為總銷售額扣除行政成本，退款中或成功退款等金額之最終利潤。</p>
                  </b-tooltip>
                  </span>
                  <span v-if="salesOverview" class="overview-item__amount">
                    {{ formatCurrency(salesOverview.profitTotal) }}</span>
                </div>
              </div>
            </div>
        </MySwiperSlide>
        <MySwiperSlide v-if="role === 'admin'">
          <div class="overview-item">
            <div class="d-flex flex-wrap">
                <div class="haft">
                  <span class="overview-item__label">總平台費
                  <img class="overview-item__icon"
                      src="../../assets/img/help-24px-blue.svg"
                      alt="Hover for help"
                      id="tooltip-merchant-agent-fee"
                  />
                  <b-tooltip
                    target="tooltip-merchant-agent-fee"
                    placement="top"
                    variant="light"
                  >
                    <p style="text-align:left;">總平台費 = 總銷售額 * 0.05</p>
                  </b-tooltip>
                  </span>
                  <span v-if="salesOverview" class="overview-item__amount">
                    {{ formatCurrency(salesOverview.platformFee) }}</span>
                </div>
              </div>
            </div>
        </MySwiperSlide>
       <MySwiperSlide v-if="role === 'admin'">
          <div class="overview-item">
            <div class="d-flex flex-wrap">
                <div class="haft">
                  <span class="overview-item__label">退款總金額
                  <img class="overview-item__icon"
                      src="../../assets/img/help-24px-blue.svg"
                      alt="Hover for help"
                      id="tooltip-merchant-refund-price"
                  />
                  <b-tooltip
                    target="tooltip-merchant-refund-price"
                    placement="top"
                    variant="light"
                  >
                    <p style="text-align:left;">退款總額 = 退款總額 + 退款總額 1 + 退款總額 2 + 退款總額 n+...</p>
                  </b-tooltip>
                  </span>
                  <span v-if="salesOverview" class="overview-item__amount">
                    {{ formatCurrency(salesOverview.refundTotal) }}</span>
                </div>
              </div>
            </div>
          </MySwiperSlide>
        </MySwiper>
    </div>

    <TheListingTitle
      title="訂單列表"
      :selectedKeywordAndFilters="selectedKeywordAndFilters"
      @reset-click="initialize"
    >
    </TheListingTitle>
    <section class="table-content">
      <template>
        <BaseFilterToolbar @reset="initialize" :loading="loading">
        <div class="d-flex">
          <label>
            <b-form-select class="filter keyword-select" v-model="filter.keywordType">
               <b-form-select-option
                  v-for="option in filteredKeywordSelectOptions"
                  :value="option.value"
                  :key="option.text"
                >
                  {{ option.text }}
                </b-form-select-option>
            </b-form-select>
          </label>
          <label id="keyword-filter">
            <input
              v-model.trim="keyword"
              type="text"
              class="form-control"
              placeholder="關鍵字..."
              aria-label="關鍵字..."
              aria-describedby="button-addon1"
            />
          </label>
        </div>
          <label>
            <b-form-select class="filter" v-model="filter.status">
              <b-form-select-option
                v-for="option in filteredStatusSelectOptions"
                :value="option.value"
                :key="option.text"
              >
                {{ option.text }}
              </b-form-select-option>
            </b-form-select>
          </label>
          <template v-slot:end>
            <BaseButton v-stream:click="exportData$" class="app--mobile-hidden">匯出</BaseButton>
          </template>
        </BaseFilterToolbar>
        <DataTable
          v-show="list"
          :fields="fields"
          :mobileFields="mobileFields"
          :items="list"
          :total-result="total"
          :options.sync="options"
          :loading="loading"
          selectable
          @row-clicked="goToItem"
          @row-selected="onRowSelected"
          mobile-searchable
          mobile-exportable
          v-stream:export-click="exportData$"
          showRowDetails
        >
          <template v-slot:cell(status)="{ value }">
            <StatusLabel :item="value"></StatusLabel>
          </template>
          <template v-slot:cell(rewardId)="{ value }">
            <router-link :to="{ path: `${role === 'admin' ? '/admin' : ''}/coupons/${value}`}">
            {{ value }}</router-link>
          </template>
          <template v-slot:cell(rewardName)="{ item }">

            <div class="d-flex">
              <img v-if="item.photo" class="data-table__cover mr-2"
              :src="item.photo">
              <div>
                {{ item.rewardName }}
                <br>
                <div class="text-secondary" style="font-size: 0.8rem;">{{ item.ref }}</div>
              </div>
            </div>
          </template>

          <!-- mobile only -->
          <template v-slot:rewardId="{ item }">
            <router-link
              :to="{ path: `${role === 'admin' ? '/admin' : ''}/coupons/${item.rewardId}` }"
            >
              {{ item.rewardId }}
            </router-link>
          </template>
          <!-- end of mobile only -->
        </DataTable>
        <b-skeleton-table v-if="!list" :rows="15" :columns="5"></b-skeleton-table>
      </template>
    </section>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { scheduled, asyncScheduler } from 'rxjs';
import {
  tap, map, switchMap, debounceTime, distinctUntilChanged, pluck, mergeAll,
} from 'rxjs/operators';
import {
  BFormSelect, BFormSelectOption, BContainer, BSkeletonTable, BTooltip,
} from 'bootstrap-vue';
import isEqual from 'lodash/isEqual';
import { getPaymentCouponStatus } from '@/helpers/coupon-status';
import axios from 'axios';
import DateTimePicker from '@/components/DateTimePicker.vue';
import formatCurrency from '@/helpers/currency';
import BaseButton from '@/components/BaseButton.vue';
import MySwiper from '@/components/my-swiper/MySwiper.vue';
import MySwiperSlide from '@/components/my-swiper/MySwiperSlide.vue';
import dataTableMixin from '../../mixins/data-table';
import exportMixin from '../../mixins/export';
import filtersQueryStringMixin from '../../mixins/filtersQueryString';
import optionsQueryStringMixin from '../../mixins/optionsQueryString';
import http from '../../helpers/http';
import TheTitle from '../../components/TheTitle.vue';
import TheListingTitle from '../../components/TheListingTitle.vue';
import OverviewList from '../../components/overview/OverviewList.vue';

import DataTable from '../../components/DataTable.vue';
import StatusLabel from '../../components/StatusLabel.vue';
import imagePath from '../../filters/image-path';
import BaseFilterToolbar from '../../components/BaseFilterToolbar.vue';

const MERCHANT_HEADERS = [
  { key: 'rewardName', label: '優惠名稱', sortable: true },
  { key: 'tags', label: '分類' },
  { key: 'rewardId', label: '商品編號', sortable: true },
  { key: 'totalPrice', label: '訂單總額', sortable: true },
  { key: 'quantity', label: '數量', sortable: true },
  {
    key: 'status',
    label: '狀態',
    sortable: true,
    formatter: (value, key, item) => getPaymentCouponStatus(item.status),
  },
  { key: 'redeemTime', label: '交易時間', sortable: true },
];
const ADMIN_HEADERS = [
  { key: 'rewardName', label: '優惠名稱', sortable: true },
  { key: 'tags', label: '分類' },
  { key: 'merchantId', label: '商户編號', sortable: true },
  { key: 'merchantName', label: '商户名稱', sortable: true },
  { key: 'brandName', label: '品牌名稱', sortable: true },
  { key: 'rewardId', label: '商品編號', sortable: true },
  { key: 'userName', label: '會員名稱', sortable: true },
  { key: 'userId', label: '會員編號', sortable: true },
  { key: 'totalPrice', label: '訂單總額', sortable: true },
  { key: 'quantity', label: '數量', sortable: true },
  {
    key: 'status',
    label: '狀態',
    sortable: true,
    formatter: (value, key, item) => getPaymentCouponStatus(item.status),
  },
  { key: 'redeemTime', label: '交易時間', sortable: true },
];

const MOBILE_HEADER = [
  {
    key: 'rewardName',
    label: '優惠名稱',
  },
  {
    key: 'status',
    formatter: (value, key, item) => getPaymentCouponStatus(item.status),
    thStyle: {
      display: 'none',
    },
  },
];

export default {
  mixins: [dataTableMixin, exportMixin, filtersQueryStringMixin, optionsQueryStringMixin],
  components: {
    BFormSelect,
    BFormSelectOption,
    BContainer,
    BSkeletonTable,
    TheTitle,
    TheListingTitle,
    OverviewList,
    DataTable,
    StatusLabel,
    BTooltip,
    BaseButton,
    DateTimePicker,
    BaseFilterToolbar,
    MySwiper,
    MySwiperSlide,
  },
  data: () => ({
    filter: {
      keywordType: 'all',
      status: undefined,
    },
    options: {
      sortBy: 'redemptionId',
    },
    keyword: '',
    keywordSelectOptions: [
      { value: 'all', text: '所有關鍵字' },
      { value: 'ref', text: '訂單編號' },
      { value: 'rewardName', text: '優惠名稱' },
      { value: 'rewardId', text: '商品編號' },
      { value: 'merchantId', text: '商戶編號', adminOnly: true },
      { value: 'merchantName', text: '商戶名稱', adminOnly: true },
      { value: 'userId', text: '會員編號', adminOnly: true },
      { value: 'userName', text: '會員名稱', adminOnly: true },
      { value: 'brandName', text: '品牌名稱', adminOnly: true },
    ],
    statusSelectOptions: [
      { value: undefined, text: '所有狀態' },
      { value: 'REDEEMED', text: '已完成' },
      { value: 'REFUND_PENDING', text: '退款中' },
      { value: 'REFUND_FINISHED', text: '已退款' },
    ],
    totalSalesAmount: 0,
    dateRange: null,
    selected: [],
    oldStatusSelected: '',
    excelName: '',
    mobileFields: MOBILE_HEADER,
  }),
  computed: {
    ...mapGetters(['role']),
    fields() {
      return this.role === 'admin' ? ADMIN_HEADERS : MERCHANT_HEADERS;
    },
  },
  filters: {
    imagePath,
  },
  domStreams: ['onOverviewSelect$', 'exportData$'],
  subscriptions() {
    const getData$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/salesorder`,
    }, data);

    const getOverViewData$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/salesorder/profitOverView`,
    }, data);

    const getOverViewStatusData$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/coupons/countByRedeemStatus`,
    }, data);

    const onOverviewsUpdate$ = this.$watchAsObservable('overviews', { deep: true }).pipe(
      pluck('newValue'),
    );

    const onDateRangeUpdate$ = this.$watchAsObservable('dateRange').pipe(
      pluck('newValue'),
      tap((dateRange) => {
        if (dateRange) {
          [this.filter.startDate, this.filter.endDate] = dateRange;
        } else {
          this.filter.startDate = null;
          this.filter.endDate = null;
        }
      }),
    );

    return {
      tags: http({
        method: 'GET',
        url: `/agc-${this.role}-api/tags`,
      }).pipe(map(({ result }) => result)),
      exportData: this.exportData$.pipe(
        switchMap(() => axios({
          method: 'GET',
          url: `/agc-${this.role}-api/export/salesOrderRecords`,
          params: {
            ...this.filter,
            q: this.keyword,
            selectedItem: this.selected.map((item) => item.redemptionId).join(','),
          },
          responseType: 'blob',
        }).then((res) => {
          this.downloadFile(res.data, this.generateFileName('sales-order-list-data'));
        })),
      ),
      list: scheduled(
        [...this.scheduleTasks, onDateRangeUpdate$],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        tap(() => {
          this.loading = true;
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        distinctUntilChanged(isEqual),
        pluck('data'),

        switchMap(getData$),
        map((list) => list.map((item) => {
          // mobile issue only: fix image keep rerender if the imagePath is put in the img tag
          item.photo = imagePath(item.photo, 'couponCover');
          return item;
        })),
      ),

      salesOverview: scheduled(
        [...this.scheduleTasks, onDateRangeUpdate$],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        tap(() => {
          this.loading = true;
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        distinctUntilChanged(isEqual),
        pluck('data'),

        switchMap(getOverViewData$),
      ),
      overviews: scheduled(
        [...this.scheduleTasks, onDateRangeUpdate$],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        tap(() => {
          this.loading = true;
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        distinctUntilChanged(isEqual),
        pluck('data'),

        switchMap(getOverViewStatusData$),
      ),

      // overviews: http({
      //   method: 'GET',
      //   url: `/agc-${this.role}-api/coupons/countByRedeemStatus`,
      // }),

      onOverviewSelect: this.onOverviewSelect$.pipe(
        pluck('event', 'msg'),
        tap((status) => {
          // console.log('current:', status);
          // console.log('old:', this.oldStatusSelected);
          switch (status) {
            case 'TOTAL':
              this.filter.status = undefined;
              break;
            case 'TOTAL_COUPON':
              this.filter.status = undefined;
              break;
            case 'REDEEMED':
              if (status === this.oldStatusSelected || this.filter.status === undefined) {
                this.filter.status = this.filter.status === 'REDEEMED' ? undefined : 'REDEEMED';
              } else {
                this.filter.status = 'REDEEMED';
              }
              this.oldStatusSelected = 'REDEEMED';
              break;
            case 'REDEEMED_COUPON':
              if (status === this.oldStatusSelected || this.filter.status === undefined) {
                console.log('asadsda:', this.filter.status);
                this.filter.status = this.filter.status === 'REDEEMED' ? undefined : 'REDEEMED';
              } else {
                this.filter.status = 'REDEEMED';
              }
              this.oldStatusSelected = 'REDEEMED_COUPON';
              break;
            case 'REFUND_PENDING':
              if (status === this.oldStatusSelected || this.filter.status === undefined) {
                this.filter.status = this.filter.status === 'REFUND_PENDING' ? undefined : 'REFUND_PENDING';
              } else {
                this.filter.status = 'REFUND_PENDING';
              }
              this.oldStatusSelected = 'REFUND_PENDING';
              break;
            case 'REFUND_PENDING_COUPON':
              if (status === this.oldStatusSelected || this.filter.status === undefined) {
                this.filter.status = this.filter.status === 'REFUND_PENDING' ? undefined : 'REFUND_PENDING';
              } else {
                this.filter.status = 'REFUND_PENDING';
              }
              this.oldStatusSelected = 'REFUND_PENDING_COUPON';
              break;
            case 'REFUND_FINISHED':
              if (status === this.oldStatusSelected || this.filter.status === undefined) {
                this.filter.status = this.filter.status === 'REFUND_FINISHED' ? undefined : 'REFUND_FINISHED';
              } else {
                this.filter.status = 'REFUND_FINISHED';
              }
              this.oldStatusSelected = 'REFUND_FINISHED';
              break;
            case 'REFUND_FINISHED_COUPON':
              if (status === this.oldStatusSelected || this.filter.status === undefined) {
                this.filter.status = this.filter.status === 'REFUND_FINISHED' ? undefined : 'REFUND_FINISHED';
              } else {
                this.filter.status = 'REFUND_FINISHED';
              }
              this.oldStatusSelected = 'REFUND_FINISHED_COUPON';
              break;
            default:
              this.filter.status = this.filter.status === status ? undefined : status;
          }
        }),
      ),
      isEmptyState: onOverviewsUpdate$.pipe(
        map((overviews) => overviews
          .every(({ totalPrice }) => totalPrice === 0)),
      ),
    };
  },
  methods: {
    goToItem({ redemptionId }) {
      this.$router.push({
        path: `${this.role === 'admin' ? '/admin' : ''}/salesorder/${redemptionId}`,
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    initialize() {
      this.filter.keywordType = 'all';
      this.keyword = '';
      this.filter.status = undefined;
      this.dateRange = null;
      setTimeout(() => {
        this.loading = false;
      }, 550);
      // when user updates filter too fast, the loading state will not set back to false
      // this time must be bigger than debounceTime's time
    },
    formatCurrency,
  },

};
</script>

<style scoped lang="scss">
@import '../../assets/scss/data-table/list-table-content';
@import '../../assets/scss/listing/header';

.overview-item {
  border: 1px solid #dde1e5;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 20px 18px 20px 20px;

  @include respond(phone) {
    padding: 20px 10px;
  }

  &:hover {
    & img {
      transform: scale(1.06);
    }
  }

  &__amount {
    color: #3A4047;
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 36px;
    display: block;
    font-family: Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;

    @include respond(tab-landscape) {
      font-size: 1.5rem;
    }

    @include respond(phone) {
      font-size: 1.1rem;
    }
  }

  &__label {
    color: #696969;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 21px;
    display: block;

  }

  & img  {
    width: 14px;
    height: 14px;
    transition: transform 0.5s;
    margin-bottom: 4px;
  }
}

.overview {
  h2 {
    color: #174169;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 25px;
    margin-bottom: 1rem;
    display:inline-block;
  }

  h3 {
    color: #E9967A;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 25px;
    margin-bottom: 1rem;
  }

  .row {
    margin: 0 -6px;

    .mb-2 {
      padding: 0 6px;
      margin-bottom: 1.5rem !important;
    }
  }

  #pinkborder {
    border-radius: 5px;
    background:#FFE4E1;
    margin-left: 20px;
    padding-left: 10px;
    padding-right: 10px;
  }
}

.haft {
  max-width: 100%;
  padding: 0;

  @include respond(phone) {
    max-width: 100%;
  }
}
</style>
